// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from "./UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
import { FormatTime } from '../utils/FormatTime';
/* END-USER-IMPORTS */

export default class Timer extends UserComponent {

  constructor(gameObject: Phaser.GameObjects.Text) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)["__Timer"] = this;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: Phaser.GameObjects.Text): Timer {
    return (gameObject as any)["__Timer"];
  }

  private gameObject: Phaser.GameObjects.Text;
  public isRunning: boolean = false;
  public time: number = 0;
  public isPaused:boolean = false;
  public totalSeconds: number = 0;
  public totalMinutes: number = 0;

  /* START-USER-CODE */

  // Write your code here.

  startTimer(): Timer {
    this.isRunning = true;

    return this;
  }

  stopTimer(): Timer {
    this.isRunning = false;
    let that = this;
    this.gameObject.scene.tweens.addCounter({
      from: this.time,
      to: 0,
      onUpdate: function (tween) {
        let ft = FormatTime.timeInMinAndSec(tween.getValue());
        that.gameObject.setText(FormatTime.timeToMMSS(ft));
      }
    });
    this.time = 0;
    
    return this;
  }

  pauseTimer(): Timer {
    this.isPaused = true;
    return this;
  }

  unpauseTimer(): Timer {
    this.isPaused = false;
    return this;
  }

  resetTimer(): Timer {
    this.time = 0;

    return this;
  }

  getTime(): number {
    return this.time;
  }

  update(time: number, delta: number) {
    if (this.isRunning && !this.isPaused) {
      this.time += delta / 1000;

      // Once we hit 59:59 there's not much point continuing.
      if (this.time >= 3600) {
        this.time = 3599;
        this.isRunning = false;
      }

      let ft = FormatTime.timeInMinAndSec(this.time);
      ({ minutes: this.totalMinutes, seconds: this.totalSeconds } = ft);
      this.gameObject.setText(FormatTime.timeToMMSS(ft));
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
